import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";
import UtilService from "../../../services/UtilService";

const AdminCrossService = {
    requestPuzzle: async (pageModel, sort, keyword, setRows, setRowCount) => {
        let params = {
            page: pageModel.page,
            pageSize: pageModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
            keyword: keyword,
        };

        const result = await ApiService.getData("/v1/puzzle/cross", params);

        const mapped = result.content.map((r) => {
            return {
                id: r.id,
                title: r.title,
                letters: r.letters,
                state: r.state,
                "cloudUser.email": r.cloudUser.email,
                createdAt: UtilService.formatDate(r.createdAt),
            };
        });

        setRows(mapped);
        setRowCount(result.page?.totalElements ?? 0);
    },

    requestPuzzleDetail: async (crossId, setPuzzle) => {
        const result = await ApiService.getData(`/v1/puzzle/cross/${crossId}`);
        setPuzzle(result);
        return result;
    },

    requestPuzzlePlay: async (crossId, keyword, pageModel, sort, setRows, setRowCount, isCompleted, testAccountFilter = "exclude", excludeStaff = true) => {
        let params = {
            page: pageModel.page,
            pageSize: pageModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
        };

        if (crossId) {
            params["crossId"] = crossId;
        }

        if (keyword) {
            params["keyword"] = keyword;
        }

        if (isCompleted !== null) {
            params["isCompleted"] = isCompleted;
        }

        if (testAccountFilter === "exclude") {
            params.testAccount = false;
        } else if (testAccountFilter === "include") {
            params.testAccount = true;
        }
        if (excludeStaff) {
            params.staff = false;
        }

        const result = await ApiService.getData(`/v1/puzzle/cross-play`, params);

        // Get puzzle type if crossId is provided
        let puzzleType = 'CROSSWORD'; // default
        if (crossId) {
            try {
                const puzzleDetail = await ApiService.getData(`/v1/puzzle/cross/${crossId}`);
                puzzleType = puzzleDetail.type || 'CROSSWORD';
            } catch (error) {
                Logger.error('Error fetching puzzle type:', error);
            }
        }

        const mapped = result?.content.map((row) => {
            // Calculate percentage based on puzzle type
            let percentage = 0;
            if (row.hidden?.words && row.foundWords) {

                const totalWords = row.hidden.words.split('\n').filter(word => word.trim()).length;
                const foundWordsCount = row.foundWords.split('\n').filter(word => word.trim()).length;

                if (totalWords > 0) {
                    if (puzzleType === 'CROSSWORD') {
                        // For CROSSWORD: percentage = (foundWords / totalWords) * 100
                        percentage = Math.round((foundWordsCount / totalWords) * 100);
                    }
                }
            }

            return {
                id: row.id,
                foundWords: row.foundWords,
                hidden: row.hidden,
                percentage: percentage,
                name: row.cloudUser?.firstName + " " + (row.cloudUser?.lastName ?? "").trim(),
                email: row.cloudUser?.email,
                startedAt: UtilService.formatDate(row.startedAt),
                finishedAt: UtilService.formatDate(row.finishedAt),
                isCompleted: row.isCompleted,
                attemptsCount: row.attemptsCount,
                hintUsed: row.hintUsed,
                cross: row.cross,
                cloudUser: row.cloudUser,
            };
        });

        setRows(mapped);
        setRowCount(result.page?.totalElements ?? 0);
    },

    deleteCrossPlay: async (crossPlayIds) => {
        try {
            // Handle both single ID and multiple IDs
            const ids = Array.isArray(crossPlayIds) ? crossPlayIds : [crossPlayIds];
            await ApiService.deleteData(`/v1/puzzle/cross-play`, { crossPlayIds: ids });
            return true;
        } catch (error) {
            Logger.error('Error deleting cross play:', error);
            throw error;
        }
    },

};

export default AdminCrossService;

